import { datadogRum } from "@datadog/browser-rum";
import { useFiltersV2Actions, useFiltersV2Select } from "PFApp/components/filters_v2/stores";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useSavedFiltersDelete } from "PFCore/hooks/queries/filters/use_saved_filters_delete";
import { Id } from "PFCore/types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { DD_SAVED_FILTER_DELETE } from "../../datadog_actions";

type SavedFiltersCollectionDeleteModalProps = {
  id: Id;
  name: string;
  onClose: VoidFunction;
  isSelected: boolean;
};

export const SavedFiltersCollectionDeleteModal = ({
  id,
  name,
  isSelected,
  onClose
}: SavedFiltersCollectionDeleteModalProps) => {
  const { t } = useTranslation("filters", { keyPrefix: "delete" });
  const { collection } = useFiltersV2Select("collection");
  const { resetBufferValues } = useFiltersV2Actions();
  const { mutateAsync: deleteSavedFilter } = useSavedFiltersDelete(collection!);

  const handleDelete = useCallback(() => {
    datadogRum.addAction(DD_SAVED_FILTER_DELETE, {
      id,
      name
    });

    deleteSavedFilter(id);
    if (isSelected) {
      resetBufferValues();
    }
  }, [deleteSavedFilter, isSelected, resetBufferValues, id, name]);

  return (
    <Modal
      title={t("confirmTitle")}
      labelOK={t("action")}
      kindOK="danger"
      onOK={handleDelete}
      onClose={onClose}
    >
      <Typography variant="bodyRegular">{t("confirmMessage")}</Typography>
    </Modal>
  );
};
